import { usePageSections } from '@/api/rpc/hooks/page-sections/usePageSections';
import type {
  PageSectionNavGroup,
  TaskPageNavItem,
} from '@/routing/task-pages-nav';

/**
 * The org-created page sections the sidebar needs titles for. Only fetched
 * once at least one visible page targets a section — an org without custom
 * sections never issues the request, and a user who can see pages already
 * holds the read grant the sections list requires. Empty while loading.
 */
export function usePageSectionNavGroups(
  pageItems: readonly TaskPageNavItem[],
): PageSectionNavGroup[] {
  const enabled = pageItems.some((item) => item.pageSectionId !== null);
  const { data: pageSections } = usePageSections({ enabled });
  if (!enabled || !pageSections) return [];
  return pageSections;
}
